export const messages = {
  fa: {
    home: 'خانه',
    grades: 'صنف ها',
    bookmarks: 'نشان شده ها',
    profile: 'پروفایل',
    teachers: 'استادان',
    posts: 'پست ها',
    lessons: 'مضامین',
    view_all: 'مشاهده همه',
    library: 'کتابخانه',
    teachers_profile: 'پروفایل استادان',
    last_seen: 'آخرین عناوین مشاهده شده',
    search_placeholder: 'جستجوی نام استاد',
    login_email_title: 'لطفاً ایمیل خود را وارد کنید',
    email_placeholder: 'ایمیل',
    login_terms: 'ورود به منزله پذیرش',
    terms_conditions: 'شرایط و قوانین',
    privacy: 'حریم خصوصی',
    submit_continue: 'ثبت و ادامه',
    loading: 'در حال دریافت معلومات...',
    send_otp: 'در حال ارسال...',
    about_lesson: 'درباره مضمون',
    qa: 'پرسش و پاسخ',
    exam: 'امتحان',
    teacher: 'استاد',
    time: 'زمان',
    your_question: 'سوال شما',
    write_question: 'سوال خود را بنویسید...',
    send: 'ارسال',
    cancel: 'انصراف',
    ask_question: 'پرسش سوال',
    exam_count: 'بار امتحان دادید',
    score: 'نمره',
    passed_exam: 'شما در این آزمون کامیاب شدید',
    failed_exam: 'نیاز به امتحان مجدد',
    start_exam: 'شروع آزمون',
    finish_exam: 'پایان',
    share_post: 'از این پست دیدن کنید',
    share_lesson: 'از این مضمون دیدن کنید',
    share_profile: 'از این پروفایل دیدن کنید',
    follow: 'دنبال کردن',
    followed: 'دنبال شده',
    followers: 'دنبال کنندگان',
    create_chat: 'ایجاد گفتگو',
    bio: 'بیوگرافی',
    empty_list: 'موردی یافت نشد',
    user_area: 'ناحیه کاربری',
    change_lang: 'تغییر زبان اپلیکیشن',
    edit_profile: 'ویرایش مشخصات',
    lesson_topics: 'عناوین درسی',
    exams: 'امتحانات',
    qa_lessons: 'پرسش و پاسخ های درسی',
    chart_lessons: 'گراف درسی',
    certificate: 'شهادتنامه پایان دوره',
    about_us: 'درباره ما',
    contact_us: 'تماس با ما',
    logout: 'خروج از کاربری',
    app_intro: 'معرفی اپلیکیشن',
    select_lang: 'زبان اپلیکیشن را انتخاب کنید',
    select_role: 'نقش خود را مشخص کنید',
    i_am_teacher: 'استاد هستم',
    i_am_student: 'شاگرد هستم',
    persian_dari: 'فارسی دری',
    pashto: 'پشتو',
    grade_access_denied: 'دسترسی به این صنف تعلیمی برای شما مقدور نیست',
    understand: 'فهمیدم',
    hello_dear: 'عزیز سلام',
    exit_confirm_title: 'آیا مطمئن هستید میخواهید از اپلیکیشن خارج شوید؟',
    yes_exit: 'بله میخواهم خارج شوم',
    no_stay: 'نخیر خارج نمیشوم',
    no_bio: 'بیوگرافی ثبت نشده است.',
    exam_incomplete: 'شما به همه سوالات پاسخ ندادید. آیا مطمئن هستید؟',
    error_submit: 'اشتباه در ثبت معلومات',
    success_submit: 'با موفقیت ثبت شد',
    attention: 'توجه',
    exam_already_passed: 'چون قبلا امتحان دادید و کامیاب شدید دیگر نمیتوانید امتحان بدهید',
    communication_error: 'مشکل در برقراری ارتباط',
    teacher_user_area: 'ناحیه کاربری استاد',
    my_chats: 'گفتگوهای من',
    add_post: 'افزودن پست',
    my_profile: 'پروفایل من',
    teacher_home: 'خانه استاد',
    upload_image: 'آپلود تصویر',
    insert_desc: 'درج توضیحات',
    write_desc: 'توضیحات خود را بنویسید...',
    submit_post: 'ثبت پست',
    click_to_select: 'برای انتخاب کلیک کنید',
    successful_submit: 'با موفقیت ثبت شد',
    upload_error: 'مشکل در آپلود',
    connection_error: 'مشکل در اتصال',
    search_student: 'جستجوی نام شاگرد',
    no_chat: 'گفتگویی یافت نشد',
    unseen: 'خوانده نشده',
    read: 'خوانده شده',
    sent: 'ارسال شده',
    type_message: 'پیام خود را بنویسید...',
    send_success: 'ارسال شد',
    contact_teacher: 'تماس با پشتیبانی',
    msg_title: 'عنوان پیام',
    msg_text: 'متن پیام',
    write_subject: 'موضوع پیام را بنویسید...',
    write_explanation: 'توضیحات خود را بنویسید...',
    course_qa: 'پرسش و پاسخ دوره ها',
    not_answered: 'پاسخ داده نشده',
    answered: 'پاسخ داده شده',
    no_new_question: 'سوال جدیدی نیست',
    your_answer: 'پاسخ شما',
    write_answer: 'پاسخ خود را بنویسید...',
    submit_answer: 'ثبت پاسخ',
    progress_chart: 'گراف پیشرفت',
    edit_profile_info: 'ویرایش مشخصات فردی',
    name: 'نام',
    family: 'تخلص',
    father_name: 'نام پدر',
    father_family: 'تخلص پدر',
    country: 'کشور',
    age: 'سن',
    degree: 'درجه تحصیلی',
    job_docs: 'اسناد شغلی',
    upload_mandatory: 'الزامی',
    upload_optional: 'اختیاری',
    exists: 'موجود است',
    uploading: 'در حال آپلود...',
    teaching_grades: 'صنف های تدریسی من',
    you_teach_lessons: 'شما مدرس مضامین ذیل می باشید',
    you_teach_grades: 'شما صنف های ذیل را تدریس می کنید',
    lesson_count: 'تعداد مضامین',
    grade_count: 'تعداد صنف ها',
    followers_list: 'لیست دنبال کنندگان',
    no_followers: 'دنبال کننده ای ندارید',
    profile_settings: 'تنظیمات پروفایل من',
    course_qa_btn: 'پرسش و پاسخ دوره ها',
    exams_btn: 'امتحانات',
    my_chats_btn: 'گفتگوهای من',
    likes: 'لایک ها',
    no_likes: 'لایکی وجود ندارد',
    post_details: 'جزئیات پست',
    post_info_not_found: 'معلومات پست یافت نشد',
    request_registration: 'ثبت درخواست تدریس',
    what_lesson: 'قصد آموزش چه مضمونی دارید؟',
    what_grade: 'قصد آموزش در چه صنفی دارید؟',
    strength_point: 'توانمندی یا نقطه قوت خود را شرح دهید',
    optional: 'اختیاری',
    register_app: 'ثبت نام در اپلیکیشن',
    fill_required: 'لطفاً فیلدهای اجباری را پر کنید',
    exam_list: 'لیست امتحانات',
    retake_exams: 'امتحانات دوباره',
    passed_exams: 'امتحانات کامیاب شده',
    student_guide: 'رهنمای شاگرد',
    add_note: 'افزودن یادداشت',
    view_sheet: 'مشاهده پارچه امتحان',
    passed: 'کامیاب',
    failed: 'ناکام',
    correct_answer: 'پاسخ صحیح',
    student_answer: 'پاسخ شاگرد',
    sheet_title: 'پارچه امتحان',
    delete_post_confirm: 'آیا مطمئن هستید میخواهید این پست را حذف کنید؟',
    yes: 'بلی',
    no: 'نخیر',
    view_post: 'نمایش پست',
    edit_post: 'ویرایش پست',
    delete_post: 'حذف پست',
    post_settings: 'تنظیمات پست',
    bio_edit: 'ویرایش بیوگرافی',
    join_teachers: 'به مدرسین آینده من ملحق بشو',
    student_name: 'نام شاگرد',
    guide_master: 'رهنمای استاد',
    no_item_found: 'موردی یافت نشد',
    otp_code_sent: 'کد ارسال شده به ایمیل را وارد کنید',
    check_spam: 'لطفاً پوشه اسپم را چک کنید',
    resend: 'ارسال مجدد',
    correct_email: 'اصلاح ایمیل',
    select_pic_type: 'انتخاب نوع عکس پروفایل',
    local_avatar: 'انتخاب آواتار',
    gallery_select: 'انتخاب از گالری',
    confirm: 'تایید',
    register_next_grade: 'ثبت نام پایه بعدی',
    next_grade_confirm_title: 'آیا از درخواست ثبت نام برای پایه تحصیلی سال بعدت مطمعنی؟',
    next_grade_confirm_desc: 'درخواستت پس از ثبت شدن توسط مدیر بررسی میشود و در صورتی که پایه تحصیلی فعلی را با موفقیت به پایان رسانده بودی اجازه ورود به سال بعد را دریافت میکنی.',
    yes_sure: 'بله مطمعنم',
  },
  ps: {
    home: 'کور',
    grades: 'ټولګي',
    bookmarks: 'نښان شوي',
    profile: 'پروفایل',
    teachers: 'استادان',
    posts: 'پوسټونه',
    lessons: 'درسونه',
    view_all: 'ټول لیدل',
    library: 'کتابتون',
    teachers_profile: 'د استادانو پروفایل',
    last_seen: 'وروستي لیدل شوي سرلیکونه',
    search_placeholder: 'د استاد نوم لټون',
    login_email_title: 'مهرباني وکړئ خپل بریښنالیک دننه کړئ',
    email_placeholder: 'بریښنالیک',
    login_terms: 'ننوتل د منلو په معنی دي',
    terms_conditions: 'شرایط او قوانین',
    privacy: 'محرمیت',
    submit_continue: 'ثبت او دوام',
    loading: 'د معلوماتو ترلاسه کول...',
    send_otp: 'د لیږلو په حال کې...',
    about_lesson: 'د درس په اړه',
    qa: 'پوښتنې او ځوابونه',
    exam: 'ازموینه',
    teacher: 'استاد',
    time: 'وخت',
    your_question: 'ستاسو پوښتنه',
    write_question: 'خپله پوښتنه ولیکئ...',
    send: 'لیږل',
    cancel: 'لغوه کول',
    ask_question: 'پوښتنه کول',
    exam_count: 'ځله ازموینه ورکړې',
    score: 'نمره',
    passed_exam: 'تاسو په دې ازموینه کې بریالي شوي یاست',
    failed_exam: 'بیا ازموینې ته اړتیا ده',
    start_exam: 'ازموینه پیل کړئ',
    finish_exam: 'پای',
    share_post: 'د دې پوسټ څخه لیدنه وکړئ',
    share_lesson: 'د دې درس څخه لیدنه وکړئ',
    share_profile: 'د دې پروفایل څخه لیدنه وکړئ',
    follow: 'تعقیب کول',
    followed: 'تعقیب شوی',
    followers: 'تعقیب کونکي',
    create_chat: 'خبرې اترې پیل کړئ',
    bio: 'بیوګرافي',
    empty_list: 'هیڅ شی ونه موندل شو',
    user_area: 'د کارونکي ساحه',
    change_lang: 'د اپلیکیشن ژبه بدل کړئ',
    edit_profile: 'توضیحات سم کړئ',
    lesson_topics: 'د درس سرلیکونه',
    exams: 'ازموینې',
    qa_lessons: 'د درس پوښتنې او ځوابونه',
    chart_lessons: 'درسي چارټ',
    certificate: 'د دورې پای سند',
    about_us: 'زموږ په اړه',
    contact_us: 'موږ سره اړیکه',
    logout: 'وتل',
    app_intro: 'د اپلیکیشن پیژندنه',
    select_lang: 'د اپلیکیشن ژبه وټاکئ',
    select_role: 'خپل رول مشخص کړئ',
    i_am_teacher: 'زه ښوونکی یم',
    i_am_student: 'زه زده کونکی یم',
    persian_dari: 'فارسی دری',
    pashto: 'پښتو',
    grade_access_denied: 'تاسو دې تعلیمي درجې ته لاسرسی نلرئ',
    understand: 'پوه شوم',
    hello_dear: 'ګرانه، سلام',
    exit_confirm_title: 'ایا تاسو ډاډه یاست چې غواړئ له اپلیکیشن څخه ووځئ؟',
    yes_exit: 'هو، زه غواړم ووځم',
    no_stay: 'نه، زه نه وځم',
    no_bio: 'بیوګرافي نه ده ثبت شوې.',
    exam_incomplete: 'تاسو ټولو پوښتنو ته ځواب نه دی ورکړی. ایا تاسو ډاډه یاست؟',
    error_submit: 'د معلوماتو په ثبتولو کې تېروتنه',
    success_submit: 'په بریالیتوب سره ثبت شو',
    attention: 'پاملرنه',
    exam_already_passed: 'څرنګه چې تاسو دمخه ازموینه ورکړې او بریالي شوي یاست، تاسو نشئ کولی بیا ازموینه ورکړئ',
    communication_error: 'د اړیکې تېروتنه',
    teacher_user_area: 'د ښوونکي کاري ساحه',
    my_chats: 'زما خبرې اترې',
    add_post: 'پوسټ اضافه کول',
    my_profile: 'زما پروفایل',
    teacher_home: 'د ښوونکي کور',
    upload_image: 'انځور پورته کړئ',
    insert_desc: 'توضیحات',
    write_desc: 'خپل توضیحات ولیکئ...',
    submit_post: 'پوسټ ثبت کړئ',
    click_to_select: 'د ټاکلو لپاره کلیک وکړئ',
    successful_submit: 'په بریالیتوب سره ثبت شو',
    upload_error: 'د پورته کولو تېروتنه',
    connection_error: 'د اړیکې تېروتنه',
    search_student: 'د زده کونکي نوم لټون',
    no_chat: 'هیڅ خبرې اترې ونه موندل شوې',
    unseen: 'نه لیدل شوی',
    read: 'لوستل شوی',
    sent: 'لیږل شوی',
    type_message: 'خپل پیغام ولیکئ...',
    send_success: 'ولیږل شو',
    contact_teacher: 'له ملاتړ سره اړیکه',
    msg_title: 'د پیغام سرلیک',
    msg_text: 'د پیغام متن',
    write_subject: 'د پیغام موضوع ولیکئ...',
    write_explanation: 'خپل توضیحات ولیکئ...',
    course_qa: 'د کورس پوښتنې او ځوابونه',
    not_answered: 'ځواب نه دی ورکړل شوی',
    answered: 'ځواب ورکړل شوی',
    no_new_question: 'نوې پوښتنه نشته',
    your_answer: 'ستاسو ځواب',
    write_answer: 'خپل ځواب ولیکئ...',
    submit_answer: 'ځواب ثبت کړئ',
    progress_chart: 'د پرمختګ چارټ',
    edit_profile_info: 'د شخصي مشخصاتو سمون',
    name: 'نوم',
    family: 'تخلص',
    father_name: 'د پلار نوم',
    father_family: 'د پلار تخلص',
    country: 'هیواد',
    age: 'عمر',
    degree: 'تحصیلي درجه',
    job_docs: 'کاري اسناد',
    upload_mandatory: 'اړین',
    upload_optional: 'اختیاري',
    exists: 'شتون لري',
    uploading: 'د پورته کولو په حال کې...',
    teaching_grades: 'زما تدریسي ټولګي',
    you_teach_lessons: 'تاسو د لاندې درسونو ښوونکی یاست',
    you_teach_grades: 'تاسو لاندې ټولګي تدریس کوئ',
    lesson_count: 'د درسونو شمیر',
    grade_count: 'د ټولګیو شمیر',
    followers_list: 'د تعقیب کونکو لیست',
    no_followers: 'تعقیب کونکی نلرئ',
    profile_settings: 'زما د پروفایل تنظیمات',
    course_qa_btn: 'د کورس پوښتنې او ځوابونه',
    exams_btn: 'ازموینې',
    my_chats_btn: 'زما خبرې اترې',
    likes: 'خوښونې',
    no_likes: 'هیڅ خوښونه نشته',
    post_details: 'د پوسټ توضیحات',
    post_info_not_found: 'د پوسټ معلومات ونه موندل شول',
    request_registration: 'د تدریس غوښتنه ثبتول',
    what_lesson: 'تاسو د کوم درس ښوولو اراده لرئ؟',
    what_grade: 'تاسو په کوم ټولګي کې د ښوولو اراده لرئ؟',
    strength_point: 'خپل وړتیا یا قوي نقطه تشریح کړئ',
    optional: 'اختیاري',
    register_app: 'په اپلیکیشن کې نوم لیکنه',
    fill_required: 'مهرباني وکړئ اړین ډګرونه ډک کړئ',
    exam_list: 'د ازموینو لیست',
    retake_exams: 'بیا ازموینې',
    passed_exams: 'بریالي شوي ازموینې',
    student_guide: 'د زده کونکي لارښود',
    add_note: 'یادداشت اضافه کول',
    view_sheet: 'د ځواب پاڼې لیدل',
    passed: 'بریالی',
    failed: 'ناکامه',
    correct_answer: 'سم ځواب',
    student_answer: 'د زده کونکي ځواب',
    sheet_title: 'د ازموینې ځواب پاڼه',
    delete_post_confirm: 'ایا تاسو ډاډه یاست چې غواړئ دا پوسټ حذف کړئ؟',
    yes: 'هو',
    no: 'نه',
    view_post: 'پوسټ لیدل',
    edit_post: 'پوسټ سمول',
    delete_post: 'پوسټ حذف کول',
    post_settings: 'د پوسټ تنظیمات',
    bio_edit: 'بیوګرافي سمول',
    join_teachers: 'د راتلونکي ښوونکو سره یوځای شئ',
    student_name: 'د زده کونکي نوم',
    guide_master: 'د استاد لارښود',
    no_item_found: 'هیڅ شی ونه موندل شو',
    otp_code_sent: 'بریښنالیک ته لیږل شوی کوډ دننه کړئ',
    check_spam: 'مهرباني وکړئ د خپل بریښنالیک سپیم فولډر وګورئ',
    resend: 'بیا لیږل',
    correct_email: 'بریښنالیک سم کړئ',
    select_pic_type: 'د پروفایل عکس ډول وټاکئ',
    local_avatar: 'ځایی اواتار وټاکئ',
    gallery_select: 'له ګالري څخه وټاکئ',
    confirm: 'تایید',
    register_next_grade: 'د بلې درجې نوم لیکنه',
    next_grade_confirm_title: 'ایا تاسو ډاډه یاست چې د راتلونکي کال تحصیلي درجې لپاره نوم لیکنه غواړئ؟',
    next_grade_confirm_desc: 'ستاسو غوښتنه به د ثبت وروسته د مدیر لخوا وڅیړل شي او که تاسو اوسنۍ تحصیلي درجه په بریالیتوب سره پای ته رسولې وي، نو تاسو به راتلونکي کال ته د ننوتلو اجازه ترلاسه کړئ.',
    yes_sure: 'هو ډاډه یم',
  }
}